<error-error-content 
  image="assets/img/images/error-images/image5.png"
  errorType="BAD_GATEWAY"
  copy="ERROR_502"></error-error-content>
